// redux/features/staffModalSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
    refreshData: null,
};

const staffModalSlice = createSlice({
  name: "staffModal",
  initialState,
  reducers: {
    openStaffModal: (state,action) => {
      state.isOpen = true;
        state.refreshData = action.payload?.refreshData || null;
    },
    closeStaffModal: (state) => {
      state.isOpen = false;
        state.refreshData = null;
    },
  },
});

export const {
  openStaffModal,
  closeStaffModal,
} = staffModalSlice.actions;

export default staffModalSlice.reducer;